import { lazy } from "react";
import { Navigate } from "react-router-dom";
import type { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const CareersPage = lazy(() => import("../pages/careers/page"));
const NewsDetailPage = lazy(() => import("../pages/news-detail/[slug]/page"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy/page"));
const TermsOfServicePage = lazy(() => import("../pages/terms-of-service/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "/news/:slug",
    element: <NewsDetailPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  ...(["en", "ja", "zh-CN"] as const).map((language) => ({
    path: `/${language}/privacy-policy`,
    element: <PrivacyPolicyPage language={language} />,
  })),
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
